import { exists } from '@/api'

export interface TodayStatus {
  lendCount: number
  lendUserCount: number
  returnCount: number
  returnUserCount: number
  reserveCount: number
  reserveUserCount: number
  referenceCount: number
}

export const defaultTodayStatus = (): TodayStatus => ({
  lendCount: 0,
  lendUserCount: 0,
  returnCount: 0,
  returnUserCount: 0,
  reserveCount: 0,
  reserveUserCount: 0,
  referenceCount: 0
})

export function TodayStatusFromJSON(json: any): TodayStatus {
  return {
    lendCount: exists(json, 'lend_count') ? json.lend_count : 0,
    lendUserCount: exists(json, 'lend_user_count') ? json.lend_user_count : 0,
    returnCount: exists(json, 'return_count') ? json.return_count : 0,
    returnUserCount: exists(json, 'return_user_count')
      ? json.return_user_count
      : 0,
    reserveCount: exists(json, 'reserve_count') ? json.reserve_count : 0,
    reserveUserCount: exists(json, 'reserve_user_count')
      ? json.reserve_user_count
      : 0,
    referenceCount: exists(json, 'reference_count') ? json.reference_count : 0
  }
}
